import React, { useContext, useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

import { useRemoteStrings } from '@acorns/web-utils'
import { compose } from 'recompose'

import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { ActionType, PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getFlow } from 'utils/FlowProvider/utils'
import { FunnelContext } from 'utils/FunnelContext'

import ProgressImage from '../assets/progress-image.svg'
import { getStepsData } from '../shared/StepsData'
import { ActionWrapper, Container, StyledTitle } from '../shared/styled-components'
import {
  StyledButton,
  StyledFootnote,
  StyledImage,
  Wrapper,
  WrapperBackground,
} from '../shared/styled-components'
import { VerticalProgressBar } from '../shared/VerticalProgressBar'
import { NextButtonTappedEvent, ScreenViewedEvent } from './events'
import { BodyPush } from './styled-components'

type Props = WithFlowRouterProps

const enhance = compose<Props, {}>(withFlowRouter)

const MOCProgressStepTwo: React.FunctionComponent = ({ route }) => {
  const isMobile = useMediaQuery({ maxWidth: `${theme.breakpoints.sm}px` })
  const { isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const { getRemoteString } = useRemoteStrings()

  const stepsData = getStepsData({ getRemoteString })

  useEffect(() => {
    trackEvent('Screen Viewed', {
      eventData: ScreenViewedEvent,
      flow: getFlow(),
    })
  }, [])

  const handleNext = () => {
    trackEvent('Button Tapped', {
      eventData: NextButtonTappedEvent,
      flow: getFlow(),
    })
    isDynamicFunnelEnabled
      ? routeToPage(PageName.ProgressScreen_2, ActionType.Continue)
      : route({ from: FlowRoute.MOCProgressStepTwo, action: 'continue' })
  }

  return (
    <>
      <Nav back={true} hideHeader={isMobile} />
      <Layout>
        <Wrapper>
          <Container>
            <StyledTitle data-testid={TestIDs.MOC_PROGRESS_TWO.TITLE}>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_2.headline' })}
            </StyledTitle>
            <BodyPush />
            <VerticalProgressBar index={1} steps={stepsData} progress={50} />
            <StyledFootnote>
              {getRemoteString({ key: 'registration.moc_feature_lander.footnote' })}
            </StyledFootnote>
            {!isMobile && <StyledImage src={ProgressImage} alt="Mighty Oak Card" />}
          </Container>
        </Wrapper>
        <WrapperBackground backgroundUrl={isMobile ? ProgressImage : ''}>
          <ActionWrapper>
            <Separator />
            <StyledButton data-testid={TestIDs.MOC_PROGRESS_TWO.NEXT_BUTTON} onPress={handleNext}>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_2.cta.next' })}
            </StyledButton>
          </ActionWrapper>
        </WrapperBackground>
      </Layout>
    </>
  )
}

export default enhance(MOCProgressStepTwo)
